module.exports = __webpack_public_path__ + "img/header-engagementRingsExclusive@2x.bd6a74d.webp";